document.addEventListener('DOMContentLoaded',()=>{const t=document.querySelector('[data-mobile-toggle]');const n=document.querySelector('[data-mobile-nav]');if(t&&n)t.addEventListener('click',()=>n.classList.toggle('is-open'));});

document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = () => window.matchMedia('(min-width: 821px)').matches;

  document.querySelectorAll('.nav-dropdown').forEach((dropdown) => {
    const summary = dropdown.querySelector('.nav-dropdown__summary');
    if (!summary) return;

    dropdown.addEventListener('mouseenter', () => {
      if (isDesktop()) dropdown.setAttribute('open', '');
    });

    dropdown.addEventListener('mouseleave', () => {
      if (isDesktop()) dropdown.removeAttribute('open');
    });

    summary.addEventListener('click', (event) => {
      if (isDesktop()) {
        event.preventDefault();
        dropdown.removeAttribute('open');
      }
    });
  });

  window.addEventListener('resize', () => {
    if (isDesktop()) {
      document.querySelectorAll('.nav-dropdown').forEach((dropdown) => {
        dropdown.removeAttribute('open');
      });
    }
  });
});

// CoralPrime v1.14 — cart drawer + AJAX add-to-cart
(() => {
  const money = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-drawer-overlay]');
  if (!drawer || !overlay) return;

  // Mobile browsers use the full cart page, without an overlay or scroll lock.
  const cartLink = document.querySelector('[data-cart-drawer-open]');
  const cartUrl = cartLink?.getAttribute('href') || '/cart';
  let drawerTimer;
  const closeDrawer = () => {
    clearTimeout(drawerTimer);
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('cart-drawer-open');
  };
  const goToCart = () => {
    closeDrawer();
    window.location.assign(cartUrl);
  };
  const openDrawer = () => {
    if (window.matchMedia('(max-width: 820px)').matches) {
      goToCart();
      return;
    }
    clearTimeout(drawerTimer);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    document.body.classList.add('cart-drawer-open');
    drawerTimer = setTimeout(() => {
      if (!drawer.classList.contains('is-open')) return;
      const rect = drawer.getBoundingClientRect();
      const style = window.getComputedStyle(drawer);
      const x = Math.max(0, rect.left) + Math.min(rect.width / 2, 100);
      const y = Math.max(0, rect.top) + Math.min(rect.height / 2, 100);
      const visible = drawer.isConnected && rect.width > 0 && rect.height > 0 &&
        x < window.innerWidth && y < window.innerHeight &&
        style.display !== 'none' && style.visibility === 'visible' &&
        Number(style.opacity) > 0 && drawer.contains(document.elementFromPoint(x, y));
      if (!visible) goToCart();
    }, 450);
  };
  // Never restore a stale modal lock when returning from another page or app.
  window.addEventListener('pageshow', closeDrawer);
  window.addEventListener('pagehide', closeDrawer);
  window.addEventListener('resize', () => {
    if (window.matchMedia('(max-width: 820px)').matches) closeDrawer();
  });

  document.querySelectorAll('[data-cart-drawer-open]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  document.querySelectorAll('[data-cart-drawer-close]').forEach((el) => el.addEventListener('click', closeDrawer));
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  const renderCart = (cart) => {
    document.dispatchEvent(new CustomEvent('cp:cart-updated', { detail: cart }));
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    const count = drawer.querySelector('[data-cart-drawer-count]');
    if (count) count.textContent = `(${cart.item_count})`;
    const body = drawer.querySelector('[data-cart-drawer-body]');
    const footer = drawer.querySelector('[data-cart-drawer-footer]');
    const subtotal = drawer.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (footer) footer.hidden = cart.item_count === 0;
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-drawer__empty"><div class="cart-drawer__empty-icon">🛍</div><strong>Dein Warenkorb ist leer.</strong><span>Entdecke deine nächsten Korallen.</span></div>';
      return;
    }
    body.innerHTML = `<div class="cart-drawer__items">${cart.items.map((item, i) => `
      <div class="cart-drawer__item">
        <a class="cart-drawer__media" href="${item.url}">${item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}">` : ''}</a>
        <div class="cart-drawer__item-info">
          <a class="cart-drawer__title" href="${item.url}">${item.product_title}</a>
          <div class="cart-drawer__meta">${item.quantity} × ${money(item.final_price)}</div>
          <a class="cart-drawer__remove" href="/cart/change?line=${i + 1}&quantity=0" data-drawer-remove data-line="${i + 1}">Entfernen</a>
        </div>
        <strong class="cart-drawer__line-price">${money(item.final_line_price)}</strong>
      </div>`).join('')}</div>`;
    body.querySelectorAll('[data-drawer-remove]').forEach((link) => link.addEventListener('click', async (e) => {
      e.preventDefault();
      await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ line:Number(link.dataset.line), quantity:0 }) });
      const updated = await fetch('/cart.js').then(r => r.json());
      renderCart(updated);
    }));
  };

  document.querySelectorAll('form.product-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('.product-add');
      if (!btn || btn.disabled) return;
      const original = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = 'Wird hinzugefügt…';
      try {
        const response = await fetch('/cart/add.js', { method:'POST', body:new FormData(form), headers:{'Accept':'application/json'} });
        if (!response.ok) throw new Error('add failed');
        const cart = await fetch('/cart.js').then(r => r.json());
        renderCart(cart);
        btn.textContent = 'Im Warenkorb ✓';
        openDrawer();
        if (form.querySelector('input[name="quantity"][type="hidden"]')) btn.disabled = true;
        setTimeout(() => { if (!btn.disabled) btn.textContent = original; }, 1800);
      } catch (err) {
        btn.textContent = 'Bitte erneut versuchen';
        setTimeout(() => { btn.textContent = original; }, 1800);
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  });
})();
